import type { SimpleFieldConfig } from "@/components/shared/UniversalCRMTable/types";

export const assetsFields = {
  image_url: {
    type: "text",
    label: "Image URL",
    sortable: false,
    filterable: false,
    searchable: false,
    resizable: true,
    hideable: true,
    editable: true,
    formSpan: 3,
    width: 280,
    minWidth: 200,
    maxWidth: 400,
    placeholder: "https://westtn.consulting/img/offerings/...-web.webp",
    icon: "Image",
    allowedRoles: ["wtc_admin", "wtc_crm"],
    mobileDetailSectionId: "assets",
  },
  one_pager_pdf_url: {
    type: "text",
    label: "One-Pager PDF",
    sortable: false,
    filterable: false,
    searchable: false,
    resizable: true,
    hideable: true,
    editable: true,
    formSpan: 3,
    width: 280,
    minWidth: 200,
    maxWidth: 400,
    placeholder: "Google Drive link to one-pager PDF",
    icon: "FileText",
    allowedRoles: ["wtc_admin", "wtc_crm"],
    mobileDetailSectionId: "assets",
  },
  delivery_kit: {
    type: "textarea",
    label: "Delivery Kit",
    sortable: false,
    filterable: false,
    searchable: true,
    resizable: true,
    hideable: true,
    editable: true,
    formSpan: 3,
    width: 300,
    minWidth: 200,
    maxWidth: 500,
    placeholder: "Internal: how engineers execute the work",
    icon: "Wrench",
    allowedRoles: ["wtc_admin", "wtc_crm"],
    mobileDetailSectionId: "assets",
  },
} satisfies Record<string, SimpleFieldConfig>;
